import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { useIsTotalPriceEnabledForStateCountry } from 'hooks/use-is-total-price-enabled-for-state-country';
export const ALL_IN_PRICING_VARIANTS = {
    /**
     * Excluded from AB test
     */
    OFF: 'off', // Excluded from AB test
    /**
     * Included in AB test - baseline with total price off
     */
    OFF_WITH_NO_MARKETING: 'off_no_marketing',
    /**
     * Included in AB test - baseline with total price on
     */
    ON_WITH_NO_MARKETING: 'on_no_marketing',
    /**
     * Included in AB test - total price on with marketing messaging
     */
    ON_WITH_MARKETING: 'on_with_marketing',
};
export const useAllInPricingVariant = () => {
    const variant = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_ALL_IN_PRICING);
    const isTotalPriceEnabledForStateCountry = useIsTotalPriceEnabledForStateCountry();
    if (isTotalPriceEnabledForStateCountry) {
        return ALL_IN_PRICING_VARIANTS.OFF;
    }
    return variant;
};
